import AppLayout from './layout';

function App() {
    return (
        <AppLayout />
    );
}

export default App;
